<script setup>
import _ from 'lodash'
import SubscribePlanItemHeader from './SubscribePlanItemHeader.vue';
import SubscribePlanItemDescription from './SubscribePlanItemDescription.vue';

const props = defineProps({
  plan: {
    type: Object,
  },
  isYearly: {
    type: Boolean
  },
  productType: {
    type: String
  }
})

</script>

<template>
	<section class="relative bg-surface-2 rounded-xl flex flex-col transition-shadow"
    :class="plan.info?.popular ? 'ring-2 ring-main shadow-xl shadow-main/10 lg:z-10' : 'ring-1 ring-surface-3'">
    <span v-if="plan.info?.popular"
      class="absolute -top-3 left-1/2 -translate-x-1/2 bg-main text-white text-tiny font-semibold px-3 py-1 rounded-full shadow-md z-20 whitespace-nowrap">
      Most Popular
    </span>
    <SubscribePlanItemHeader :plan="props.plan" :is-yearly="props.isYearly" :product-type="productType" />
    <SubscribePlanItemDescription :plan="props.plan" :is-yearly="props.isYearly" />
  </section>
</template>

<style>
</style>
